import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconRocketSvg } from "./IconRocketSvg.mjs";
const IconRocket = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconRocketSvg, ...svgProps }) });
export {
  IconRocket
};
